<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Apparato CardioCircolatorio" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Toni Cardiaci:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoCardioCircolatorio.toniCardiaci }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoCardioCircolatorio.toniCardiaci" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Frequenza Cardiaca:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoCardioCircolatorio.frequenzaCardiaca }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoCardioCircolatorio.frequenzaCardiaca" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Pressione Arteriosa:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoCardioCircolatorio.pressioneArteriosa }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoCardioCircolatorio.pressioneArteriosa" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Polsi Periferici:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoCardioCircolatorio.polsiPeriferici }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoCardioCircolatorio.polsiPeriferici" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Edemi Declivi e Cianosi:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoCardioCircolatorio.edemiDecliviCianosi }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoCardioCircolatorio.edemiDecliviCianosi" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataApparatoCardioCircolatorio.id" @click="onSalvaApparatoCardioCircolatorio"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataApparatoCardioCircolatorio: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    toniCardiaci: "",
                    frequenzaCardiaca: "",
                    pressioneArteriosa: "",
                    polsiPeriferici: "",
                    edemiDecliviCianosi: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataApparatoCardioCircolatorio: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaApparatoCardioCircolatorio: "/rsaschedarelazionesanitariaapparatocardiocircolatorio",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaApparatoCardioCircolatorio() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaApparatoCardioCircolatorio + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaApparatoCardioCircolatorioSuccess, me.resultResponseSchedaRelazioneSanitariaAnamnesiFamiliareError);
        },

        resultResponseSchedaRelazioneSanitariaApparatoCardioCircolatorioSuccess(response) {
            let me = this;
            me.jsonDataApparatoCardioCircolatorio = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaApparatoCardioCircolatorioError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataApparatoCardioCircolatorio = {
                id: null,
                idAccettazione: this.idAccettazione,
                toniCardiaci: "",
                frequenzaCardiaca: "",
                pressioneArteriosa: "",
                polsiPeriferici: "",
                edemiDecliviCianosi: "",
            };
        },

        onSalvaApparatoCardioCircolatorio() {
            let me = this;
            me.jsonDataApparatoCardioCircolatorio.idAccettazione = me.idAccettazione;
            if (!me.jsonDataApparatoCardioCircolatorio.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaApparatoCardioCircolatorio, me.jsonDataApparatoCardioCircolatorio, me.saveSchedaRelazioneSanitariaApparatoCardioCircolatorioSuccessResponse, me.saveSchedaRelazioneSanitariaFarmacologicaErrorResponse);
        },
        saveSchedaRelazioneSanitariaApparatoCardioCircolatorioSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Apparato cardiocircolatorio salvato con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaApparatoCardioCircolatorioErrorResponse() {
            console.error("Errore nel salvataggio dell'apparato cardiocircolatorio:");
        },
    },
};
</script>
